/* eslint-disable react/react-in-jsx-scope */
import { Route, Switch, useHistory, RouteComponentProps } from 'react-router-dom'
import { RootState } from './Store'
import { useSelector } from 'react-redux'
import { useAuth } from './Hooks/Shared'
import { Navbar, NavbarTitle, Container, Background, Button } from './Components'
import styled from 'styled-components'
import Logo from './Assets/logo.png'
import { PageTitle } from './Pages/Shared/PageTitle'
import AuthService from './Auth/AuthService'
import React from 'react'
import { ModalEscolhaPerfil } from './Pages/Projeto/components/ModalEscolhaPerfil'

const NotFoundPage = React.lazy(() => import(/* webpackPrefetch: true */
/* webpackChunkName: "notfound" */ './Pages/NotFound'))
const AlunoIndexPage = React.lazy(() => import(/* webpackPrefetch: true */
/* webpackChunkName: "alunoindex" */ './Pages/Aluno'))
const ProfessorIndexPage = React.lazy(() => import(/* webpackPrefetch: true */
/* webpackChunkName: "professorindex" */ './Pages/Projeto'))

const StyledButton = styled(Button)`
  margin-left: auto;
`

const LabelPerfil = styled.span`
  display: block;
  font-size: 14px;
  font-weight: normal;
  margin-top: 6px;
`

const StyledAnchor = styled.a`
  text-decoration: none;
`

const ButtonProfile = styled.button`
  background-color: #757ce8;
  font-weight: 400;
  color: white;
  border-width: 0.1rem;
  border-color: gray;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
            background-color: #3f51b5;
        }
`

const App = ({ match }: RouteComponentProps<string>) => {
  const { isLoggedIn } = useAuth()
  const { roles } = useAuth()
  const history = useHistory()
  const perfil = /\/([^/?&]*)/.exec(history.location.pathname)![1] || ''
  const currentUser = useSelector((state: RootState) => state.Auth.currentUser)
  const [isModalOpen, setModal] = React.useState(false)

  const logout = () => {
    const authService = new AuthService()
    authService.logout()
  }

  return (
    <>
      {isLoggedIn && (
        <>
          <Navbar color="primaryColor" isFlat={true}>
            <NavbarTitle>
              {currentUser?.name} 
              <LabelPerfil>
                ({perfil})  {currentUser?.tipoUsuario[0] !== 'aluno' ?
                  <ButtonProfile onClick={() =>  setModal(true)}>Alterar Perfil</ButtonProfile>
                  :false}
              </LabelPerfil>
            </NavbarTitle>
            <ModalEscolhaPerfil isModalOpen={isModalOpen} roles={roles} setModal={setModal} />
            <StyledButton type="button" color="primaryLightColor" onClick={logout}>
              Sair
            </StyledButton>
          </Navbar>
          <Background color="primaryColor" />
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <StyledAnchor href={`${match.path}${perfil}/projeto`}>
              <img style={{ width: '10rem' }} src={Logo} />
              <PageTitle />
            </StyledAnchor>
          </div>
          <Container style={{ width: '960px' }} phone="100%" tablet="75%">
          <React.Suspense fallback={<p><strong>Carregando...</strong></p>}>
            <Switch>
              <Route path="/funcionario" component={ProfessorIndexPage} />
              <Route path="/coordenadoric" component={ProfessorIndexPage} />
              <Route path="/coordenadornp" component={ProfessorIndexPage} />
              <Route path="/orientador" component={ProfessorIndexPage} />
              <Route path="/aluno" component={AlunoIndexPage} />
              <Route path="*" exact={true} component={NotFoundPage} />
            </Switch>
            </React.Suspense>
          </Container>
        </>
      )}
    </>
  )
}
export default App
